"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncValidatePromoCode = exports.asyncValidate = exports.validateSavedPaymentCheckout = exports.validate = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _revalidate = require("revalidate");

var _vat = require("redux/modules/vat");

var _payments = require("redux/modules/payments");

var _creditcards = require("creditcards");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var creditCardCreateValidator = function creditCardCreateValidator(f, m) {
  return (0, _revalidate.createValidator)(function (message) {
    return function (value, allValues) {
      if (allValues.paymentMethod === "cc") {
        return f(message)(value, allValues);
      } else {
        return undefined;
      }
    };
  }, m);
};

var validate = exports.validate = (0, _revalidate.combineValidators)({
  name: (0, _revalidate.isRequired)({ message: "This is who will be invoiced" }),
  address: (0, _revalidate.isRequired)({ message: "Address is required" }),
  postalCode: (0, _revalidate.isRequired)({ message: "Postal code is required" }),
  country: (0, _revalidate.isRequired)({ message: "Country is required" }),
  // states: isRequired({ message: 'State is required' }),
  city: (0, _revalidate.isRequired)({ message: "City is required" }),

  // cardNumber: creditCardCreateValidator(
  //   (message) => (value) => {
  //     if (
  //       value &&
  //       card.type(value.replace(/\s/g, "").substr(0, 4), true) ===
  //         "American Express"
  //     )
  //       return "We currently do not accept American Express cards";
  //     return value && card.isValid(value.replace(/\s/g, ""))
  //       ? undefined
  //       : message;
  //   },
  //   "The card number seems to be invalid"
  // )(),

  // cardExpiry: creditCardCreateValidator(
  //   (message) => (value) => {
  //     if (!value) return message;

  //     const clean = value.replace(/\s/g, "");
  //     const pieces = clean.split("/");
  //     const month = expiration.month.parse(pieces[0]);
  //     const year = expiration.year.parse(pieces[1], true);

  //     if (!month || !year) return message;
  //     if (!expiration.year.isValid(year) || !expiration.month.isValid(month))
  //       return message;

  //     return !expiration.isPast(month, year) ? undefined : message;
  //   },
  //   "The card expiry date seems to be invalid"
  // )(),

  // cardCvc: creditCardCreateValidator(
  //   (message) => (value, values) => {
  //     let isValid = undefined;
  //     if (values.cardNumber) {
  //       isValid = cvc.isValid(
  //         value,
  //         card.type(values.cardNumber.replace(/\s/g, "").substr(0, 4), true)
  //       );
  //     } else {
  //       isValid = cvc.isValid(value);
  //     }
  //     return isValid ? undefined : message;
  //   },
  //   "The CVC number seems to be invalid"
  // )(),

  captcha: (0, _revalidate.isRequired)({
    message: 'Please complete the captcha by selecting "I\'m not a robot" above'
  }),

  acceptTos: (0, _revalidate.createValidator)(function (message) {
    return function (value) {
      return value === true ? undefined : message;
    };
  }, "Please read and accept the Terms of Service before confirming your purchase.")()
});

var validateSavedPaymentCheckout = exports.validateSavedPaymentCheckout = (0, _revalidate.combineValidators)({
  acceptTos: (0, _revalidate.createValidator)(function (message) {
    return function (value) {
      return value === true ? undefined : message;
    };
  }, "Please read and accept the Terms of Service before confirming your purchase.")(),

  captcha: (0, _revalidate.isRequired)({
    message: 'Please complete the captcha by selecting \"I\'m not a robot\" above'
  })
});

var asyncValidate = exports.asyncValidate = function asyncValidate(values, dispatch) {
  if (values.validatingField === "vatNo") {
    if (!values.vatNo || !values.vatNo.length) {
      dispatch((0, _vat.resetVatValidation)());
      return _bluebird2.default.resolve((0, _extends3.default)({}, values.isPromoCodeValid === false && {
        promoCode: "Promo code seems to be invalid"
      }));
    }

    return dispatch((0, _vat.validateVat)({ vatNo: values.vatNo })).then(function (response) {
      if (response.vatNo.replace(/\s/g, "") === values.vatNo.replace(/\s/g, "")) {
        if (values.isPromoCodeValid === false) {
          return { promoCode: "Promo code seems to be invalid" };
        }
        return null;
      } else {
        throw new Error(); // passing the control to .catch below
      }
    }).catch(function (err) {
      return (0, _extends3.default)({
        vatNo: "We are unable to verify your VAT ID" }, values.isPromoCodeValid === false && {
        promoCode: "Promo code seems to be invalid"
      });
    });
  } else if (values.validatingField === "promoCode") {
    if (!values.promoCode) {
      dispatch((0, _payments.resetPromocodeValidation)());
      return _bluebird2.default.resolve((0, _extends3.default)({}, values.isVatValid === false && {
        vatNo: "We are unable to verify your VAT ID"
      }));
    }

    return dispatch((0, _payments.validatePromocode)({
      promoCode: values.promoCode,
      vatNo: values.vatNo,
      countryCode: values.country
    })).then(function (res) {
      if (res && res.signedPromocodeInstance && res.signedPromocodeInstance.code.replace(/\s/g, "").toLowerCase() === values.promoCode.replace(/\s/g, "").toLowerCase()) {
        if (values.isVatValid === false) {
          return { vatNo: "We are unable to verify your VAT ID" };
        }
        return null;
      } else {
        throw new Error(); // passing the control to .catch below
      }
    }).catch(function (err) {
      return (0, _extends3.default)({
        promoCode: "Promo code seems to be invalid"
      }, values.isVatValid === false && {
        vatNo: "We are unable to verify your VAT ID"
      });
    });
  } else {
    return _bluebird2.default.resolve();
  }
};

var asyncValidatePromoCode = exports.asyncValidatePromoCode = function asyncValidatePromoCode(values, dispatch) {
  if (!values.promoCode) {
    dispatch((0, _payments.resetPromocodeValidation)());
    return _bluebird2.default.resolve();
  }

  return dispatch((0, _payments.validatePromocode)({ promoCode: values.promoCode })).then(function (res) {
    if (res && res.signedPromocodeInstance && res.signedPromocodeInstance.code.replace(/\s/g, "").toLowerCase() === values.promoCode.replace(/\s/g, "").toLowerCase()) {
      return null;
    } else {
      throw new Error(); // passing the control to .catch below
    }
  }).catch(function (err) {
    return {
      promoCode: "Promo code seems to be invalid"
    };
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/paymentFormValidation.js
// module id = 1264
// module chunks = 0